import { render, staticRenderFns } from "./AttivitaMenu.vue?vue&type=template&id=96c733fa&"
import script from "./AttivitaMenu.vue?vue&type=script&lang=js&"
export * from "./AttivitaMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports